import HttpClient from './fetch_api';
import {GET_ORDER_PRESCRIPTION} from '../conf/appSetting';

export const GetPrescriptions = async (params, gatewayToken) =>
    HttpClient.get(HttpClient.concatNotNullParam(GET_ORDER_PRESCRIPTION.base, params), {
        Authorization: `Bearer ${gatewayToken}`
    });
